import React from 'react';
import { CountMarkTypes } from '@lib/components/CountMark/CountMark';

/** Width of the "More" dropdown button in pixels */
export const MORE_ITEMS_WIDTH = 52;

/** Gap between items in the tab bar */
export const TAB_GAP = 16;

/** Total offset width reserved for the "More" button (width + gap) */
export const OFFSET_WIDTH = MORE_ITEMS_WIDTH + TAB_GAP;

/** Width reserved for renderAfterTabs content */
export const AFTER_TABS_WIDTH = 52;

/**
 * Unscaled width, in px, of the sliding active-tab indicator box. The
 * indicator is sized by `transform: scaleX(targetWidth / this)`, so this is
 * only a reference length — see `.activeIndicator` in TabBar.module.scss for
 * why it must stay large.
 */
export const INDICATOR_BASE_WIDTH = 100;

export enum TabBarItemTypes {
  green = 'green',
  blue = 'blue',
  red = 'red',
  orange = 'orange',
}

export type ActiveItem = string;

export interface TabBarItem {
  component?: () => React.ReactElement;
  counter?: number;
  counterType?: CountMarkTypes;
  disabled?: boolean;
  hasError?: boolean;
  label?: React.ReactNode;
  value: ActiveItem;
  type?: TabBarItemTypes;
}

export interface TabBarItemElement extends HTMLDivElement {
  dataset: {
    id: string;
  };
}
